/* eslint-disable import/first */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect, useRef } from "react";

import { Editor } from "@tinymce/tinymce-react";
import tinymce, { Editor as TinyMCEEditor } from "tinymce";

interface IProps {
    defaultValue: string;
    onTextChange: (newText: string) => void;
}

const WysisygEditor: React.FC<IProps> = ({ defaultValue, onTextChange }) => {
    const editorRef = useRef<TinyMCEEditor | null>(null);

    useEffect(() => {
        if (editorRef.current != null && editorRef.current.getContent() !== defaultValue) {
            editorRef.current.setContent(defaultValue);
        }

    }, [defaultValue]);

    return (
        <Editor
            tinymceScriptSrc={`${process.env.PUBLIC_URL}/tinymce/tinymce.min.js`}
            onInit={(_evt, editor) => editorRef.current = editor}
            initialValue={defaultValue}
            init={{
                height: 500,
                menubar: false,
                plugins: [
                    "advlist", "autolink", "lists", "link", "image", "charmap",
                    "anchor", "searchreplace", "visualblocks", "code", "fullscreen",
                    "insertdatetime", "media", "table", "preview", "help", "wordcount"
                ],
                toolbar: "undo redo | " +
                    "bold italic forecolor | alignleft aligncenter " +
                    "alignright alignjustify | bullist numlist outdent indent | " +
                    "removeformat",
                content_style: "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }"
            }}
            onEditorChange={(content) =>
                onTextChange(content)
            }
        />
    );
};

export default WysisygEditor;